<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "StudentIndex",
};
</script>

<style></style>
